export default {
    create: {
        referrals_pool: 'Create referrals',
    },
    confirm_slots_modal: {
        heading: 'Review Your Availability',
        content: "Please confirm the time slots you've selected. We'll share these with the referring provider.",
        buttons: {
            go_back: 'Go Back',
            confirm_submit: 'Confirm & Submit',
        },
    },
    external_propose_time_page: {
        heading: 'Please select  3 available time slots',
        title: 'Propose Available Time Slots',
        description: 'Please select 3 available time slots for the consultation',
        selected_time_slots: 'Selected Time Slots',
        success: {
            heading: "You've Successfully Proposed Your Time Slots",
            content:
                "Thank you for your response. The referring provider has been notified of your availability. We'll keep you updated on the next steps and notify you once an appointment is confirmed.",
        },
        success_reschedule: {
            heading: "You've proposed new time slots",
            content: 'The patient can now choose one of these times.',
        },
        submit_time_slots: 'Submit Time Slots',
    },
}
